module.exports = __webpack_public_path__ + "static/media/section-2-image.feec2100.svg";